import { Navigate } from "react-router-dom";
import { useAuth } from "@/auth/useAuth";
import { StaffDashboard } from "./StaffDashboard";
import { TeacherDashboard } from "./TeacherDashboard";

export function DashboardPage() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "STUDENT") return <Navigate to="/my" replace />;
  if (user.role === "TEACHER") return <TeacherDashboard />;
  return <StaffDashboard />;
}
